export enum QueryKey {
    Profile = 'profile',
    DocClasses = 'docClasses',
    DocList = 'docList',
    DocListCount = 'docListCount',
    DocLists = 'docLists',
    Document = 'document',
    DocumentHeaders = 'documentHeaders',
    DocumentExternalInfo = 'documentExternalInfo',
    DocumentAnnotations = 'documentAnnotations',
    DocumentAttachments = 'documentAttachments',
    DocumentAudits = 'documentAudits',
    DocumentActions = 'documentActions',
    DocumentOcrData = 'documentOcrData',
    DocumentOcrSummary = 'documentOcrSummary',
    DocumentCoding = 'documentCoding',
    DocumentCodingDefaults = 'documentCodingDefaults',
    DocumentPagesOwners = 'documentPagesOwners',
    LinkDocumentsList = 'linkDocumentsList',
    LinkDocumentsMeta = 'LinkDocumentsMeta',
    LineSource = 'lineSource',
    CodingAccruals = 'codingAccruals',
    DocumentCopyCodingList = 'documentCopyCodingList',
    DocumentInvoiceLines = 'documentInvoiceLines',
    DocumentOrderLines = 'documentOrderLines',
    DocumentDynamicAssign = 'documentDynamicAssign',
    SearchFields = 'searchFields',
    SearchResult = 'searchResult',
    CreditorValidation = 'creditorValidation',
    File = 'file',
    FileRepaired = 'fileRepaired',
    Url = 'url',
    Comments = 'comments',
    Lookup = 'lookup',
    MailTemplates = 'mailTemplates',
    MailTemplate = 'mailTemplate',
    OcrTraining = 'ocrTraining',
    OcrTrainingLog = 'ocrTrainingLog',
    OcrCodingTraining = 'ocrCodingTraining',
    Version = 'version',
    Replacements = 'replacements',
    ReplacementsForOtherUsers = 'replacementsForOtherUsers',
    News = 'news',
    MaintenanceMessage = 'maintenanceMessage',
    FileHandlerAdministrations = 'fileHandlerAdministrations',
    SuperVisorActions = 'superVisorActions',
    SharedTemplates = 'sharedTemplates',
    Sam = 'sam',
    SamBackOfficeStatusHelp = 'samBackOfficeStatusHelp',
    SamPreview = 'samPreview',
    SamCodingLineProps = 'samCodingLineProps',
    Diagnostics = 'diagnostics',
    FieldPurchasesMeta = 'fieldPurchasesMeta',
    RoutingTable = 'routingTable',
}
